const OperationalRecommandations = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f5] p-8">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-1">
                Operational Recommendations
              </h1>
              <p className="text-sm text-gray-600">
                For field officers, Smart City Ops, and control room integration
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500">Last updated</p>
              <p className="text-sm font-semibold text-gray-900">12:14:45 PM</p>
            </div>
          </div>
        </div>

        {/* Action Trigger Table */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Action Trigger Table</h2>
          <p className="text-xs text-gray-600 mb-4">
            🔴 Each row auto-generated by real-time NLP + sensor fusion model
          </p>

          <div className="space-y-3">
            {/* Row 1 */}
            <div className="grid grid-cols-12 gap-4 items-center py-3 border-b border-gray-100">
              <div className="col-span-3 flex items-center gap-2">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-red-50">
                  <span className="text-red-600">⚠️</span>
                </div>
                <div>
                  <p className="text-xs text-gray-500">AI Signal</p>
                  <p className="text-sm font-semibold text-gray-900">High Congestion (Bhandara)</p>
                </div>
              </div>
              <div className="col-span-3">
                <p className="text-xs text-gray-500">Trigger</p>
                <p className="text-sm text-gray-900">85% capacity threshold</p>
              </div>
              <div className="col-span-4">
                <p className="text-xs text-gray-500">AI Recommendation</p>
                <p className="text-sm text-gray-900">Activate Route-C diversion</p>
              </div>
              <div className="col-span-2 text-right">
                <span className="inline-block px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded">
                  Pending
                </span>
              </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-12 gap-4 items-center py-3 border-b border-gray-100">
              <div className="col-span-3 flex items-center gap-2">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-50">
                  <span className="text-blue-600">💧</span>
                </div>
                <div>
                  <p className="text-xs text-gray-500">AI Signal</p>
                  <p className="text-sm font-semibold text-gray-900">Repeated Water Issues (Toilet A/B)</p>
                </div>
              </div>
              <div className="col-span-3">
                <p className="text-xs text-gray-500">Trigger</p>
                <p className="text-sm text-gray-900">3+ negative feedbacks in 1 hr</p>
              </div>
              <div className="col-span-4">
                <p className="text-xs text-gray-500">AI Recommendation</p>
                <p className="text-sm text-gray-900">Dispatch water maintenance team</p>
              </div>
              <div className="col-span-2 text-right">
                <span className="inline-block px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded">
                  Action Sent
                </span>
              </div>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-12 gap-4 items-center py-3 border-b border-gray-100">
              <div className="col-span-3 flex items-center gap-2">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-yellow-50">
                  <span className="text-yellow-600">💡</span>
                </div>
                <div>
                  <p className="text-xs text-gray-500">AI Signal</p>
                  <p className="text-sm font-semibold text-gray-900">Lighting Failures</p>
                </div>
              </div>
              <div className="col-span-3">
                <p className="text-xs text-gray-500">Trigger</p>
                <p className="text-sm text-gray-900">"Bulb fused" pattern</p>
              </div>
              <div className="col-span-4">
                <p className="text-xs text-gray-500">AI Recommendation</p>
                <p className="text-sm text-gray-900">Alert MPCB Control Room</p>
              </div>
              <div className="col-span-2 text-right">
                <span className="inline-block px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded">
                  Acknowledged
                </span>
              </div>
            </div>

            {/* Row 4 */}
            <div className="grid grid-cols-12 gap-4 items-center py-3">
              <div className="col-span-3 flex items-center gap-2">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-50">
                  <span className="text-green-600">👍</span>
                </div>
                <div>
                  <p className="text-xs text-gray-500">AI Signal</p>
                  <p className="text-sm font-semibold text-gray-900">Clean Sectors</p>
                </div>
              </div>
              <div className="col-span-3">
                <p className="text-xs text-gray-500">Trigger</p>
                <p className="text-sm text-gray-900">0 negative + ≥2 positive</p>
              </div>
              <div className="col-span-4">
                <p className="text-xs text-gray-500">AI Recommendation</p>
                <p className="text-sm text-gray-900">Highlight for Smart City Rewards</p>
              </div>
              <div className="col-span-2 text-right">
                <span className="inline-block px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded">
                  Queued
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Automated Daily Command Report */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg font-bold text-gray-900 mb-1">Automated Daily Command Report</h2>
          <p className="text-xs text-gray-600 mb-6">Auto-generated every 6 hours • Next update in 3h 24m</p>

          <div className="grid grid-cols-2 gap-6 mb-6">
            {/* Crowd Summary Heatmap */}
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2">
                🔥 Crowd Summary Heatmap Snapshot
              </h3>
              <div className="relative h-64">
                <svg className="w-full h-full" viewBox="0 0 400 200">
                  {/* Y-axis labels */}
                  <text x="10" y="20" className="text-xs fill-gray-600">100</text>
                  <text x="10" y="70" className="text-xs fill-gray-600">75</text>
                  <text x="10" y="120" className="text-xs fill-gray-600">50</text>
                  <text x="10" y="170" className="text-xs fill-gray-600">25</text>
                  <text x="10" y="195" className="text-xs fill-gray-600">0</text>

                  {/* X-axis labels */}
                  <text x="50" y="195" className="text-xs fill-gray-600">06:00</text>
                  <text x="120" y="195" className="text-xs fill-gray-600">08:00</text>
                  <text x="190" y="195" className="text-xs fill-gray-600">10:00</text>
                  <text x="260" y="195" className="text-xs fill-gray-600">12:00</text>
                  <text x="330" y="195" className="text-xs fill-gray-600">14:00</text>

                  {/* Area chart - Bhandara (darker) */}
                  <path
                    d="M 40 120 Q 100 100, 150 90 T 260 80 T 370 100 L 370 180 L 40 180 Z"
                    className="fill-gray-400 opacity-80"
                  />

                  {/* Area chart - Sector A (lighter) */}
                  <path
                    d="M 40 140 Q 100 130, 150 110 T 260 100 T 370 120 L 370 180 L 40 180 Z"
                    className="fill-gray-300 opacity-60"
                  />
                </svg>
              </div>
              <div className="flex items-center justify-center gap-6 mt-4">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-orange-500"></div>
                  <span className="text-xs text-gray-600">Bhandara</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-teal-500"></div>
                  <span className="text-xs text-gray-600">Sector A</span>
                </div>
              </div>
            </div>

            {/* Feedback Word Cloud */}
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
                💬 Feedback Word Cloud
              </h3>
              <p className="text-xs text-gray-500 mb-4">Frequency-based sentiment analysis</p>
              <div className="flex flex-wrap items-center justify-center gap-3 py-8">
                <span className="text-4xl font-bold text-gray-900">clean</span>
                <span className="text-3xl font-bold text-red-600">water issue</span>
                <span className="text-2xl font-semibold text-gray-900">crowded</span>
                <span className="text-lg text-gray-700">well maintained</span>
                <span className="text-lg text-gray-700">lighting</span>
                <span className="text-lg text-gray-700">excellent</span>
                <span className="text-3xl font-bold text-red-600">bulb fused</span>
                <span className="text-lg text-gray-700">organized</span>
                <span className="text-2xl font-semibold text-red-600">toilet dirty</span>
                <span className="text-lg text-gray-700">helpful staff</span>
                <span className="text-3xl font-bold text-gray-900">congestion</span>
                <span className="text-base text-gray-600">safe</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {/* AI Alert Timeline */}
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
                🚨 AI Alert Timeline
              </h3>
              <p className="text-xs text-gray-500 mb-4">Last 6 hours</p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="flex items-center gap-2 min-w-[60px]">
                    <span className="text-xs text-gray-500">⏰ 14:32</span>
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-white bg-red-600 rounded mb-1">
                      critical
                    </span>
                    <p className="text-xs text-gray-900">High congestion detected at Bhandara</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex items-center gap-2 min-w-[60px]">
                    <span className="text-xs text-gray-500">⏰ 13:15</span>
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-gray-900 bg-yellow-400 rounded mb-1">
                      warning
                    </span>
                    <p className="text-xs text-gray-900">Water pressure low in Toilet Block A</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex items-center gap-2 min-w-[60px]">
                    <span className="text-xs text-gray-500">⏰ 12:48</span>
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-white bg-gray-600 rounded mb-1">
                      info
                    </span>
                    <p className="text-xs text-gray-900">Maintenance team dispatched to Sector B</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex items-center gap-2 min-w-[60px]">
                    <span className="text-xs text-gray-500">⏰ 11:20</span>
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-white bg-green-600 rounded mb-1">
                      success
                    </span>
                    <p className="text-xs text-gray-900">Lighting issue resolved in Zone 3</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex items-center gap-2 min-w-[60px]">
                    <span className="text-xs text-gray-500">⏰ 10:55</span>
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-gray-900 bg-yellow-400 rounded mb-1">
                      warning
                    </span>
                    <p className="text-xs text-gray-900">Crowd threshold approaching 80%</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Resolved vs Pending Actions */}
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
                ✅ Resolved vs Pending Actions
              </h3>
              <div className="h-64 flex items-end justify-around gap-8 px-4 mt-8">
                {/* Congestion */}
                <div className="flex-1 flex flex-col items-center">
                  <div className="w-full flex flex-col gap-1 mb-2">
                    <div className="bg-black h-32 rounded-t"></div>
                    <div className="bg-gray-300 h-8 rounded-t"></div>
                  </div>
                  <p className="text-xs text-gray-600 text-center">Congestion</p>
                </div>

                {/* Maintenance */}
                <div className="flex-1 flex flex-col items-center">
                  <div className="w-full flex flex-col gap-1 mb-2">
                    <div className="bg-black h-12 rounded-t"></div>
                    <div className="bg-gray-300 h-16 rounded-t"></div>
                  </div>
                  <p className="text-xs text-gray-600 text-center">Maintenance</p>
                </div>

                {/* Lighting */}
                <div className="flex-1 flex flex-col items-center">
                  <div className="w-full flex flex-col gap-1 mb-2">
                    <div className="bg-black h-20 rounded-t"></div>
                    <div className="bg-gray-300 h-36 rounded-t"></div>
                  </div>
                  <p className="text-xs text-gray-600 text-center">Lighting</p>
                </div>

                {/* Sanitation */}
                <div className="flex-1 flex flex-col items-center">
                  <div className="w-full flex flex-col gap-1 mb-2">
                    <div className="bg-black h-8 rounded-t"></div>
                    <div className="bg-gray-300 h-28 rounded-t"></div>
                  </div>
                  <p className="text-xs text-gray-600 text-center">Sanitation</p>
                </div>
              </div>
              <div className="flex items-center justify-center gap-6 mt-6">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-black"></div>
                  <span className="text-xs text-gray-600">pending</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 bg-gray-300"></div>
                  <span className="text-xs text-gray-600">resolved</span>
                </div>
              </div>
            </div>
          </div>

          {/* Tomorrow's Forecast Map */}
          <div className="border border-gray-200 rounded-lg p-4 mt-6">
            <h3 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
              📊 Tomorrow's Forecast Map
            </h3>
            <p className="text-xs text-gray-500 mb-4">Predicted hotspots based on AI modeling</p>
            
            <div className="grid grid-cols-3 gap-4">
              {/* Bhandara Sector */}
              <div className="border border-red-200 rounded-lg p-4 bg-red-50">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-900">Bhandara Sector</h4>
                  <span className="text-red-600">📈</span>
                </div>
                <span className="inline-block px-2 py-1 text-xs font-medium text-red-700 bg-red-100 rounded mb-2">
                  High
                </span>
                <p className="text-xs text-gray-600">92% confidence</p>
              </div>

              {/* Toilet Block A */}
              <div className="border border-yellow-200 rounded-lg p-4 bg-yellow-50">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-900">Toilet Block A</h4>
                  <span className="text-yellow-600">📊</span>
                </div>
                <span className="inline-block px-2 py-1 text-xs font-medium text-yellow-700 bg-yellow-100 rounded mb-2">
                  Medium
                </span>
                <p className="text-xs text-gray-600">78% confidence</p>
              </div>

              {/* Sector B */}
              <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-900">Sector B</h4>
                  <span className="text-gray-600">📉</span>
                </div>
                <span className="inline-block px-2 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded mb-2">
                  Low
                </span>
                <p className="text-xs text-gray-600">85% confidence</p>
              </div>

              {/* Main Gate */}
              <div className="border border-red-200 rounded-lg p-4 bg-red-50">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-900">Main Gate</h4>
                  <span className="text-red-600">📈</span>
                </div>
                <span className="inline-block px-2 py-1 text-xs font-medium text-red-700 bg-red-100 rounded mb-2">
                  High
                </span>
                <p className="text-xs text-gray-600">88% confidence</p>
              </div>

              {/* Parking Zone */}
              <div className="border border-yellow-200 rounded-lg p-4 bg-yellow-50">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-gray-900">Parking Zone</h4>
                  <span className="text-yellow-600">📊</span>
                </div>
                <span className="inline-block px-2 py-1 text-xs font-medium text-yellow-700 bg-yellow-100 rounded mb-2">
                  Medium
                </span>
                <p className="text-xs text-gray-600">75% confidence</p>
              </div>
            </div>
          </div>
        </div>

        {/* AI Orchestration Info */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-2">AI Orchestration Info</h2>
          <p className="text-xs text-green-600 mb-4">✅ Integrated Modules</p>

          <div className="grid grid-cols-3 gap-4 mb-6">
            {/* AI Forecast Engine */}
            <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-white border border-gray-200">
                  <span className="text-xl">🔮</span>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-gray-900">AI Forecast Engine</h3>
                    <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 rounded">
                      active
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">Predictive heatmap for congestion</p>
                </div>
              </div>
            </div>

            {/* Feedback AI */}
            <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-white border border-gray-200">
                  <span className="text-xl">💬</span>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-gray-900">Feedback AI</h3>
                    <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 rounded">
                      active
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">Real-time sentiment clustering</p>
                </div>
              </div>
            </div>

            {/* Action Dispatcher */}
            <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-white border border-gray-200">
                  <span className="text-xl">⚡</span>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-gray-900">Action Dispatcher</h3>
                    <span className="px-2 py-0.5 text-xs font-medium text-green-700 bg-green-100 rounded">
                      active
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">API-based workflow to smart city systems</p>
                </div>
              </div>
            </div>
          </div>

          {/* Tech Note */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <p className="text-xs text-gray-700">
              <span className="font-semibold">Tech Note:</span> The AI module leverages heatmap analytics, 
              feedback sentiment, and ETA modeling to automatically generate a Daily Situational Intelligence Report, 
              enabling faster policy and field response.
            </p>
          </div>
        </div>

        {/* Floating Issue Badge */}
        <div className="fixed bottom-8 left-8 flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-full shadow-lg">
          <span className="text-sm font-semibold">N</span>
          <span className="text-sm">1 Issue</span>
          <button className="ml-2 text-white hover:text-gray-200">×</button>
        </div>
      </div>
    </div>
  );
};

export default OperationalRecommandations;
